"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearPersistedSessionAccountId = exports.clearPersistedSessionPublicKey = exports.clearPersistedSessionId = exports.setPersistedSessionAccountId = exports.setPersistedSessionPublicKey = exports.getPersistedSessionAccountId = exports.getPersistedSessionPublicKey = exports.getPersistedSessionId = exports.SESSION_ACCOUNTID_KEY = exports.SESSION_PUBLICKEY_KEY = exports.SESSION_ID_KEY = void 0;
var isomorphic_localstorage_1 = __importDefault(require("isomorphic-localstorage"));
var localStorage = (0, isomorphic_localstorage_1.default)('./.localstorage');
exports.SESSION_ID_KEY = 'nightly-id-near';
exports.SESSION_PUBLICKEY_KEY = 'nightly-connect-near-publickey';
exports.SESSION_ACCOUNTID_KEY = 'nightly-connect-near-accountid';
var getPersistedSessionId = function getPersistedSessionId() {
  return localStorage.getItem(exports.SESSION_ID_KEY);
};
exports.getPersistedSessionId = getPersistedSessionId;
var getPersistedSessionPublicKey = function getPersistedSessionPublicKey() {
  return localStorage.getItem(exports.SESSION_PUBLICKEY_KEY);
};
exports.getPersistedSessionPublicKey = getPersistedSessionPublicKey;
var getPersistedSessionAccountId = function getPersistedSessionAccountId() {
  return localStorage.getItem(exports.SESSION_ACCOUNTID_KEY);
};
exports.getPersistedSessionAccountId = getPersistedSessionAccountId;
var setPersistedSessionPublicKey = function setPersistedSessionPublicKey(publicKey) {
  localStorage.setItem(exports.SESSION_PUBLICKEY_KEY, publicKey);
};
exports.setPersistedSessionPublicKey = setPersistedSessionPublicKey;
var setPersistedSessionAccountId = function setPersistedSessionAccountId(accountId) {
  localStorage.setItem(exports.SESSION_ACCOUNTID_KEY, accountId);
};
exports.setPersistedSessionAccountId = setPersistedSessionAccountId;
var clearPersistedSessionId = function clearPersistedSessionId() {
  localStorage.removeItem(exports.SESSION_ID_KEY);
};
exports.clearPersistedSessionId = clearPersistedSessionId;
var clearPersistedSessionPublicKey = function clearPersistedSessionPublicKey() {
  localStorage.removeItem(exports.SESSION_PUBLICKEY_KEY);
};
exports.clearPersistedSessionPublicKey = clearPersistedSessionPublicKey;
var clearPersistedSessionAccountId = function clearPersistedSessionAccountId() {
  localStorage.removeItem(exports.SESSION_ACCOUNTID_KEY);
};
exports.clearPersistedSessionAccountId = clearPersistedSessionAccountId;